import { render, staticRenderFns } from "./ProductStatsPage.vue?vue&type=template&id=b04b9386&"
import script from "./ProductStatsPage.vue?vue&type=script&lang=js&"
export * from "./ProductStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports